/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "chatEndpoints",
            "endpoint": "https://38xsxc7oz2.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://rfut7wa32bgudlmt3olgb7iyqe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:19eee8ea-f2ed-42dc-93a4-9d7725874401",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_gj6xHk6Jp",
    "aws_user_pools_web_client_id": "6cpreg9aqnnq6jm45qvnb3gr95",
    "oauth": {
        "domain": "interview2deed40e2-deed40e2-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.interviewlabco.com/social/,http://localhost:3000/social/",
        "redirectSignOut": "https://www.interviewlabco.com/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "audio-bucket103133-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
